import { CARD_SHADOW_HOVER } from "@app/theme/tokens";
import type { SvgIconComponent } from "@mui/icons-material";
import { Box, Paper, Typography } from "@mui/material";
import { PendingValue } from "./PendingValue";

export default function KpiCard({
  label,
  value,
  suffix,
  color,
  icon: Icon,
}: {
  label: string;
  value: number | string | null;
  suffix?: string;
  color: string;
  icon: SvgIconComponent;
}) {
  return (
    <Paper
      variant="outlined"
      sx={{
        position: "relative",
        overflow: "hidden",
        p: 2,
        display: "flex",
        alignItems: "center",
        gap: 2,
        transition: "transform 180ms, box-shadow 180ms",
        "&::before": {
          content: '""',
          position: "absolute",
          inset: "0 0 auto 0",
          height: 3,
          background: `linear-gradient(90deg, ${color} 0%, ${color}33 100%)`,
        },
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: CARD_SHADOW_HOVER,
        },
      }}
    >
      <Box
        sx={{
          width: 46,
          height: 46,
          borderRadius: "50%",
          background: `linear-gradient(140deg, ${color}26 0%, ${color}0D 100%)`,
          color,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Icon />
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            fontWeight: 600,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            fontSize: "0.65rem",
          }}
        >
          {label}
        </Typography>
        {value === null ? (
          <Box>
            <PendingValue variant="kpi" />
          </Box>
        ) : (
          <Typography
            sx={{
              fontSize: "1.8rem",
              fontWeight: 800,
              lineHeight: 1.15,
              color,
            }}
          >
            {value}
            {suffix}
          </Typography>
        )}
      </Box>
    </Paper>
  );
}
